import SetUserData from "./components/SetUserData/SetUserData";

export default SetUserData;
